
jQuery(function($){

	if( $('.side-panel').length ) {
	




		// In most cases - use the 'data-side-panel' attribute
		$("[data-side-panel]").click(function() {
			$($(this).data('side-panel')).addClass('js-is-open');

			// When opening waiting list panels, check whether to show the nothing available message.
			if ($(this).hasClass('js-show-nothing-available-message-on-waiting-list-panel')) {
				// console.log('class was present!');
				$('.side-panel#waiting-list').addClass('js-show-nothing-available-message');
			}

		});

		// Edge case - for buttons in the 'section-grid-banner' block
		$(".section-grid-banner .wp-block-button__link").click(function() {
			$($(this).attr('href')).addClass('js-is-open');
		});

		$(".side-panel .icon-close").click(function() {
			closeSidePanel();
		});

		$(document).on('keydown', function(event) {
			if (event.key == "Escape") {
				closeSidePanel();
			}
		});

		// Hide side panel when the user clicks outside of it
		$(document).on('click', function(){
			closeSidePanel();
		});

		// Disable default functionality for all the links
		$('.side-panel, [data-side-panel], .section-grid-banner .wp-block-button__link').on('click', function(e){
			e.stopPropagation();
		});


		function closeSidePanel() {
			$('.side-panel').removeClass('js-is-open');
			$('.side-panel').removeClass('js-show-nothing-available-message'); //Reset
		}



	}

});


